import { grey, red, blue } from "@mui/material/colors";

export const colors = (mode) => ({
  palette: {
    mode,
    ...(mode === 'light') ?
    {
      primary: {
        light: "#eceff1",
        main: "#dee1e3",
        dark: "#818588",
        contrastText: "#000",
      },
      secondary: {
        light: "#0066ff",
        main: "#0044ff",

        // dark: will be calculated from palette.secondary.main,
        // contrastText: '#ffcc00',
      },
      divider: blue[700],
      text: {
        primary: "#000000",
        secondary: "#000000",
      },
      error: {
        main: red[900],
        contrastText: red[900],
      },
      blue: {
        main: '#2c4992',
        900: "#000000",
        50: "#000000",
        subTitle: '#2c4992'
      },
      bluePrincipal: {
        main: "#000",
      },
      colorSwitch: {
        main: "#6dbceb"
      },
      lightColor:{
        main: "#f1f6ff"
      },
      blueSys: {
        main: '#2c4992',
        contrastText: "#fff"
      },
      black: {
        main: '#000',
        contrastText: "#000"
      },
      blueOcean: {
        main: "#00a7e1",
        contrastText: "#fff"
      },
      inputColor: {
        main: grey[500],
      },
      blackInput: {
        main: '#00a7e1',
        contrastText: "#00a7e1"
      },
      textBlue: {
        main: '#00A7E1',
        contrastText: "#fff"
      },
      buttonPdf: {
        main: '#0032a0',
        contrastText: "#fff"
      }


    }
    : {
        // primary: deepOrange,
        // divider: deepOrange[700],
        // background: {
        //     default: deepOrange[900],
        //     paper: deepOrange[900],
        // },
        text: {
            primary: '#fff',
            secondary: grey[500],
        },
        blue: {
            900: '#90caf9',
            50: '#424242'
        },
        red: {
            error: '#f44336'
        },
        bluePrincipal: {
          main: "#000000",
        },
    }
  },
});
